import React from "react";
import { useTranslation } from "react-i18next";
import { Menu, Phone } from "lucide-react";

import { Button } from "./ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "./ui/sheet";

import { cn } from "../lib/utils";
import logo from "../assets/images/logo.png";

const navLinks = [
  { id: "destinations", labelKey: "appbar.destinations" },
  { id: "tours", labelKey: "appbar.tours" },
  { id: "services", labelKey: "appbar.contact" },
];

export default function ResponsiveAppBar() {
  const { t } = useTranslation();

  const renderLinks = ({
    onNavigate,
    className,
  }: { onNavigate?: () => void; className?: string } = {}) => (
    <ul
      className={cn(
        "flex flex-col gap-4 text-base font-medium md:flex-row",
        className
      )}
    >
      {navLinks.map((link) => (
        <li key={link.id}>
          <a
            href={
              link.id === "services"
                ? "https://wa.me/5548996523066"
                : `/#${link.id}`
            }
            onClick={onNavigate}
            className="transition hover:text-primary"
            target={link.id === "services" ? "_blank" : undefined}
            rel={link.id === "services" ? "noreferrer" : undefined}
          >
            {t(link.labelKey)}
          </a>
        </li>
      ))}
    </ul>
  );

  return (
    <header className="relative z-20">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-6">
        <a href="/" className="inline-flex items-center gap-2">
          <img src={logo} alt="Transfer On Floripa" className="h-10" />
          <span className="sr-only">Transfer On Floripa</span>
        </a>
        <nav className="hidden items-center gap-8 text-white md:flex">
          {renderLinks({ className: "text-white" })}
          <Button
            size="sm"
            className="border-white/20 bg-white/10 text-white hover:bg-white/20"
            asChild
          >
            <a
              href="https://wa.me/5548996523066"
              target="_blank"
              rel="noreferrer"
            >
              <Phone className="h-4 w-4" />
              WhatsApp
            </a>
          </Button>
        </nav>
        <div className="md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button size="icon" variant="ghost" className="text-white">
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent
              side="right"
              className="rounded-none border-none bg-white"
            >
              <SheetHeader>
                <SheetTitle>Transfer On Floripa</SheetTitle>
                <SheetDescription>
                  Sua viagem premium começa aqui. Transfers executivos e
                  experiências únicas em Florianópolis.
                </SheetDescription>
              </SheetHeader>
              <div className="mt-6 space-y-6">
                {renderLinks({ className: "text-slate-900" })}
                <Button className="w-full" asChild>
                  <a
                    href="https://wa.me/5548996523066"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Phone className="h-4 w-4" /> Conversar agora
                  </a>
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
